import { useState, useEffect, useContext } from "react";
import api from "../../services/api";
import { AuthContext } from "../../context/Auth/AuthContext";
import { podeAdministrarConexoes } from "../../pages/Connections/managedConnections";

/**
 * #4271 — a lista COMPLETA de conexões da empresa, para administrar.
 *
 * Fora daqui (tickets, novo ticket, transferência) a lista continua sendo a do
 * `WhatsAppsContext`, recortada ao que o usuário pode atender. Ver o porquê da
 * separação em `pages/Connections/managedConnections.js`.
 *
 * Não assina socket: quem mantém o estado em tempo real é o contexto global, e
 * a tela mescla as duas listas.
 */
const useManagedConnections = () => {
  const { user } = useContext(AuthContext);
  const [managed, setManaged] = useState(null);

  const administra = podeAdministrarConexoes(user);

  useEffect(() => {
    if (!administra) {
      setManaged(null);
      return undefined;
    }

    let vivo = true;

    const carregar = async () => {
      try {
        const { data } = await api.get("/whatsapp", {
          params: { session: 0, scope: "connections" }
        });
        if (vivo) setManaged(data);
      } catch (err) {
        // A tela não pode ficar vazia por causa disso: sem a lista
        // administrativa ela cai na do contexto (ver mergeManagedConnections).
        console.error("Erro ao carregar as conexões para administrar:", err);
        if (vivo) setManaged(null);
      }
    };

    carregar();

    return () => {
      vivo = false;
    };
  }, [administra]);

  return managed;
};

export default useManagedConnections;
